import { useEffect, useState } from "react"
import { IInformacionProyectos } from "../../../interfaces/InformacionProyectos"
import { getInfoProyectosPrograma } from "../../../api/informacionProyectos"
import { ChartContainerLoader } from "../../../components/Generic/Charts"
import ProjectListItem from "../../../components/Generic/ProjectListItem"
import { useTranslation } from "react-i18next"

const Iniciativas: React.FC<{ code: string }> = ({ code }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'iniciativas' })

    const [proyectos, setProyectos] = useState<IInformacionProyectos[]>()

    useEffect(() => {
        getInfoProyectosPrograma(code)
            .then((res) => {
                setProyectos(res);
                return
            })
    }, [code])

    if (!proyectos) {
        return (
            <ChartContainerLoader colSize="12" />
        )
    }

    return (
        <div className={`col-12`}>
            <div className="card">
                <div className="card-body">
                    <div className="row mb-1">
                        <div className="col">
                            <small>
                                {t("resultados_ini")} <strong>{proyectos.length}</strong> {t("resultados_fin")}
                            </small>
                        </div>
                    </div>
                    <ul
                        className="list-unstyled"
                    >
                        {proyectos.map((proyecto, index) => (
                            <ProjectListItem key={index} proyecto={proyecto} />
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Iniciativas